import React from "react";
import "./Home.css";

function VanOperation() {
  return (
    <div className="home-section-container">
      <div className="home-content-split">
        <div className="home-text-content">
          <div className="title-text-cont">
            <h1>VAN OPERATION</h1>
            <p className="home-subtitle">
              <img
                className="brandImg"
                style={{ backgroundColor: "white" }}
                src="/ramLogo.webp"
              />
              <br />2020 Ram Promaster
            </p>
          </div>
        </div>

        <div className="home-image-content">
          <iframe src="https://drive.google.com/file/d/1ieP2bx1osumB7UlD4INW9mmmUTyiqlaE/preview"></iframe>
        </div>
      </div>

      <div className="outdoorsy-container" style={{ textAlign: "left" }}>
        <p className="tealText">
          Remember that the van is a large vehicle. It is very top-heavy and very tall. Be mindful of low clearances. <br />
          <br />
          The gas tank is located on the driver’s side of the van, just to the right of the driver’s seat. There is a little cutout on the bottom right corner to open the door. The van takes regular unleaded gas, NO DIESEL! <br />
          <br />
          To operate cruise control, twist the knob on the bottom lever to the left of the steering wheel. This turns cruise control on. A green icon will illuminate on the dashboard. Click the lever up or down to set cruise control. If you disengage cruise control by hitting your brakes, you can resume it by pressing the button on the end of the lever. <br />
          <br />
          To fold the side mirrors in, press the little button on the driver’s side door. <br />
          <br />
          All after-market components of the van have manuals that are located under the driver’s seat.
        </p>
      </div>

      <div className="movCont">
        <img src="/radio.jpg" className="home-image" />
      </div>
    </div>
  );
}

export default VanOperation;
